import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseFormGetValues } from "react-hook-form";
import { format } from "date-fns";

import useFetch from "../useFetch";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { AddCaseResponseProps } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { AddCaseProps, PatientAttributes } from "src/pages/addCase/types";
import { CaseContext } from "src/context/caseContext";
import { AuthContext } from "src/context/authContext";



const useCaseCreateCall = (getValues: UseFormGetValues<AddCaseProps>) => {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [newCaseId, updateNewCaseId] = useState<number>();

  const navigate = useNavigate() 
  const { showToast } = useContext(ToastContext)
  const { draftCaseId } = useContext(CaseContext)
  const { userData, updateUserData } = useContext(AuthContext)

const { loading: updateFormThirdPartyLoading, data: updateFormThirdPartyData, mutate: updateFormThirdPartyMutate } =
    useFetch<AddCaseResponseProps>(APIEndpoints.UPDATE_FROM_THIRD_PARTY);
useEffect(() => {
    if (updateFormThirdPartyData) {
      // if (newCaseId)
      //   navigate(`/cases/${newCaseId}/documents/new`);
      // else
      //   navigate('/cases')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateFormThirdPartyData])


  const { mutate: uploadCaseFile, data: uploadCaseData } = useFetch(APIEndpoints.UPLOAD_CASE_FILE)

  useEffect(() => {
    if (uploadCaseData) {
      if (newCaseId)
        navigate(`/cases/${newCaseId}/documents/new`);
      else
        navigate('/cases')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadCaseData])





  /**
   * @AddNewCase form handling for case data submission
   * @fourth case submit handler
   */
  const { loading: addCaseLoading, data: addCaseData, mutate: addNewCase } =
    useFetch<AddCaseResponseProps>(APIEndpoints.ADD_NEW_CASE);

  useEffect(() => {
    if (addCaseData && addCaseData.status === 200) {
      localStorage.removeItem('newCase');
      addCaseData.global_doctor_id && updateFormThirdPartyMutate({ }, {id: addCaseData.global_doctor_id}, {})
      showToast([`Case Added Successfully!`], ToastTypes.SUCCESS);
      if (draftCaseId !== 0 && userData) {
        updateUserData({ ...userData, draft_count: userData.draft_count - 1 })
      }

      const docs = getValues("uploaded_documents");
      if (docs && docs.length > 0) {
        updateNewCaseId(addCaseData.case_id || 0)
        const formData = new FormData();
        formData.append("file", docs[0]);

        setIsUploading(true); // Start upload

        uploadCaseFile(formData, { caseId: addCaseData.case_id }, {
          onSuccess: () => {
            setIsUploading(false); // Stop upload
            showToast([`Your request submitted successfully!`], ToastTypes.SUCCESS);
            navigate(`/cases/${addCaseData.case_id}/documents/new`);
          },
          onError: () => {
            setIsUploading(false); // Stop upload in case of error
            showToast(["File upload failed. Please try again."], ToastTypes.ERROR);
          },
        });
      } else {
        showToast([`Your request submitted successfully!`], ToastTypes.SUCCESS);
        navigate(`/cases/${addCaseData.case_id}/documents/new`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addCaseData]);

  /** @fourth */
  const caseDataSubmission = () => {
    const values = getValues()
    console.log("Case Submit........",values)
    const prescription_attributes_attributes = [];
    if (values.prescription_attributes.scheduled_date_of_service) {
      prescription_attributes_attributes.push({
        name: "scheduled_date_of_service",
        value: values.prescription_attributes.scheduled_date_of_service
      });
    }
    if (values.prescription_attributes.review_type) {
      prescription_attributes_attributes.push({
        name: "review_type",
        value: values.prescription_attributes.review_type
      });
    }
    if (values.prescription_attributes.condition) {
      prescription_attributes_attributes.push({
        name: "condition",
        value: values.prescription_attributes.condition
      });
    }
    if (values.prescription_attributes.quickstart) {
      prescription_attributes_attributes.push({
        name: "quickstart",
        value: values.prescription_attributes.quickstart,
      })
    }
    if (values.prescription_attributes.frequency_of_use !== "Other" && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "frequency_of_use",
        value: values.prescription_attributes.frequency_of_use,
      })
    }else if (values.prescription_attributes.frequency_of_use === "Other" && values.prescription_attributes.other_frequency_of_use && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "frequency_of_use",
        value: values.prescription_attributes.frequency_of_use + "-" + values.prescription_attributes.other_frequency_of_use,
      })
    }
     if (values.prescription_attributes.daily_dose !== "Other" && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "daily_dose",
        value: values.prescription_attributes.daily_dose,
      })
    }else if (values.prescription_attributes.daily_dose === "Other" && values.prescription_attributes.other_daily_dose && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "daily_dose",
        value: values.prescription_attributes.daily_dose + "-" + values.prescription_attributes.other_daily_dose,
      })
    }
     if (values.prescription_attributes.supervising_md_firstname && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "supervising_md_firstname",
        value: values.prescription_attributes.supervising_md_firstname,
      })
    }

    if (values.prescription_attributes.supervising_md_lastname && values.prescription_attributes.drug_name === "Furoscix ReadyFlow Autoinjector") {
      prescription_attributes_attributes.push({
        name: "supervising_md_lastname",
        value: values.prescription_attributes.supervising_md_lastname,
      })
    }

    if (values.prescription_attributes.cp_diuretics) {
      if (values.prescription_attributes.cp_diuretics.diuretics_tried) {
        const {
          bumetanide, bumetanide_props,
          furosemide, furosemide_props,
          torsemide, torsemide_props
        } = values.prescription_attributes.cp_diuretics.diuretics_tried;

        if (bumetanide) {
          const bumetanideProps: { doses: string[], data: string[] } = {
            doses: [],
            data: []
          };
          bumetanide_props["05mg"] && bumetanideProps.doses.push("0.5mg");
          bumetanide_props["1mg"] && bumetanideProps.doses.push("1mg");
          bumetanide_props["2mg"] && bumetanideProps.doses.push("2mg");
          bumetanide_props["3mg"] && bumetanideProps.doses.push("3mg");
          bumetanide_props["4mg"] && bumetanideProps.doses.push("4mg");
          bumetanide_props.other_dose && bumetanideProps.doses.push(`${bumetanide_props.other_dosage_value}mg` || "")
          bumetanide_props.result_of_use && bumetanideProps.data.push(bumetanide_props.result_of_use);
          bumetanide_props.hospitalization_date && bumetanideProps.data.push(bumetanide_props.hospitalization_date);
          bumetanide_props.other && bumetanideProps.data.push(bumetanide_props.other);
          
          if (bumetanideProps.doses.length > 0)
            prescription_attributes_attributes.push({
              name: "bumetanide_dosage",
              value: `${bumetanideProps.doses.join(",")}`,
            })
          if (bumetanide_props.result_of_use && bumetanide_props.result_of_use.length > 0)
            prescription_attributes_attributes.push({
              name: "bumetanide_result_of_use",
              value: bumetanide_props.result_of_use,
            })
          if(bumetanide_props.hospitalization_date)
            prescription_attributes_attributes.push({
              name: "bumetanide_hospitalization_date",
              value: `${bumetanide_props.hospitalization_date}`,
            })
          if(bumetanide_props.other)
            prescription_attributes_attributes.push({
              name: "bumetanide_other",
              value: `${bumetanide_props.other}`,
            })
          // prescription_attributes_attributes.push({
          //   name: "bumetanide",
          //   value: `${bumetanideProps.doses.join(",")}#${bumetanideProps.data.join("#")}`,
          // })
        }
        if (furosemide) {
          const furosemideProps: { doses: string[], data: string[] } = {
            doses: [],
            data: []
          };
          furosemide_props["20mg"] && furosemideProps.doses.push("20mg");
          furosemide_props["40mg"] && furosemideProps.doses.push("40mg");
          furosemide_props["80mg"] && furosemideProps.doses.push("80mg");
          furosemide_props.other_dose && furosemideProps.doses.push(`${furosemide_props.other_dosage_value}mg` || "")
          furosemide_props.result_of_use && furosemideProps.data.push(furosemide_props.result_of_use);
          furosemide_props.hospitalization_date && furosemideProps.data.push(furosemide_props.hospitalization_date);
          furosemide_props.other && furosemideProps.data.push(furosemide_props.other);

          // prescription_attributes_attributes.push({
          //   name: "furosemide",
          //   value: `${furosemideProps.doses.join(",")}#${furosemideProps.data.join("#")}`,
          // })
          if (furosemideProps.doses.length > 0)
            prescription_attributes_attributes.push({
              name: "furosemide_dosage",
              value: `${furosemideProps.doses.join(",")}`,
            })
          if (furosemide_props.result_of_use && furosemide_props.result_of_use.length > 0)
            prescription_attributes_attributes.push({
              name: "furosemide_result_of_use",
              value: furosemide_props.result_of_use,
            })
          if(furosemide_props.hospitalization_date)
            prescription_attributes_attributes.push({
              name: "furosemide_hospitalization_date",
              value: `${furosemide_props.hospitalization_date}`,
            })
          if(furosemide_props.other)
            prescription_attributes_attributes.push({
              name: "furosemide_other",
              value: `${furosemide_props.other}`,
            })
        }
        if (torsemide) {
          const torsemideProps: { doses: string[], data: string[] } = {
            doses: [],
            data: []
          };
          torsemide_props["5mg"] && torsemideProps.doses.push("5mg");
          torsemide_props["10mg"] && torsemideProps.doses.push("10mg");
          torsemide_props["20mg"] && torsemideProps.doses.push("20mg");
          torsemide_props["40mg"] && torsemideProps.doses.push("40mg");
          torsemide_props["60mg"] && torsemideProps.doses.push("60mg");
          torsemide_props["100mg"] && torsemideProps.doses.push("100mg");
          torsemide_props.other_dose && torsemideProps.doses.push(`${torsemide_props.other_dosage_value}mg` || "")
          torsemide_props.result_of_use && torsemideProps.data.push(torsemide_props.result_of_use);
          torsemide_props.hospitalization_date && torsemideProps.data.push(torsemide_props.hospitalization_date);
          torsemide_props.other && torsemideProps.data.push(torsemide_props.other);

          // prescription_attributes_attributes.push({
          //   name: "torsemide",
          //   value: `${torsemideProps.doses.join(",")}#${torsemideProps.data.join("#")}`
          // })
          if (torsemideProps.doses.length > 0)
            prescription_attributes_attributes.push({
              name: "torsemide_dosage",
              value: `${torsemideProps.doses.join(",")}`,
            })
          if (torsemide_props.result_of_use && torsemide_props.result_of_use.length > 0)
            prescription_attributes_attributes.push({
              name: "torsemide_result_of_use",
              value: torsemide_props.result_of_use,
            })
          if(torsemide_props.hospitalization_date)
            prescription_attributes_attributes.push({
              name: "torsemide_hospitalization_date",
              value: `${torsemide_props.hospitalization_date}`,
            })
          if(torsemide_props.other)
            prescription_attributes_attributes.push({
              name: "torsemide_other",
              value: `${torsemide_props.other}`,
            })
        }
      }

      if (values.prescription_attributes.cp_diuretics.creatinine_clearance || values.prescription_attributes.cp_diuretics.eGFR) {
        // const lab_result = [];
        // values.prescription_attributes.cp_diuretics.creatinine_clearance
        //   && lab_result.push(values.prescription_attributes.cp_diuretics.creatinine_clearance);
        // values.prescription_attributes.cp_diuretics.eGFR
        //   && lab_result.push(values.prescription_attributes.cp_diuretics.eGFR);

        // if (lab_result.length > 0)
          prescription_attributes_attributes.push({
            name: "creatinine_clearance",
            value: values.prescription_attributes.cp_diuretics.creatinine_clearance
          })
          prescription_attributes_attributes.push({
            name: "glomerular_filtration",
            value: values.prescription_attributes.cp_diuretics.eGFR
          })
      }
      // prescription_attributes_attributes.push({
      //   name: "cp_diuretics",
      //   value: values.prescription_attributes.cp_diuretics
      // });
    }
    const { scheduled_date_of_service, cp_diuretics, injection_site, review_type,condition, quickstart,frequency_of_use,other_frequency_of_use,daily_dose,other_daily_dose,supervising_md_firstname,supervising_md_lastname, ...actualPrescription } = values.prescription_attributes ;

    const shipments_attributes = [];
    
      shipments_attributes.push({
        ship_to: "other",
        practice_id:values.doctor_attributes.practice_id
       
      });
    
    const patient_attributes_attributes = []
    if ("weight" in values.patient_attributes && values.patient_attributes.weight && values.patient_attributes.weight !== "0") {
      patient_attributes_attributes.push({
        name: "patient_weight",
        value: values.patient_attributes.weight
      })
    }
    const { weight, ...actual_patient_attributes } = values.patient_attributes as PatientAttributes;

    const newValues = {
      ...values,
      category: "rx",
      drug_name: values.prescription_attributes.drug_name,
      // ...(values.procedure_attributes ? {procedures_attributes: [
      //   { cpt_code: values.procedure_attributes.cpt_code },
      // ]} : {}),
      prescription_attributes: {
        ...actualPrescription,
        diagnosis_code: values.prescription_attributes.diagnosis_code.join(","),
        qty:values.prescription_attributes.injection_site,
        is_daw:true,
        is_speciality_pharmacy_only:0,
        written_date: format(values.prescription_attributes.written_date, "dd/MM/yyyy"),
        //ndc: dataProduct.find((drug) => values.prescription_attributes.drug_name === drug.value)?.ndc || "",
        prescription_attributes_attributes,
      },
      shipments_attributes,
      patient_attributes: {
        ...actual_patient_attributes,
        ...(patient_attributes_attributes.length > 0 ? {patient_attributes_attributes} : {})
      },
      patient_firstlastname: `${actual_patient_attributes.firstname} ${actual_patient_attributes.lastname}`,
      patient_fullname: `${actual_patient_attributes.firstname}${`${actual_patient_attributes.middlename ? ` ${actual_patient_attributes.middlename}` : ""}`} ${actual_patient_attributes.lastname}`,
      patient_dob: actual_patient_attributes.dob,
      insurances_attributes: values.insurances_attributes?.map((insurance, index) => {
        insurance.insurance_priority = index;
        return insurance;
      }),
      case_attributes_attributes: [
        {
          name: "soc",
          value: "other"
        },
        ...(values.case_attributes && values.case_attributes.pa_approved ? [{
          name: "pa_approved",
          value: values.case_attributes.pa_approved,
        }]: []),
        ...(values.case_attributes && values.case_attributes.pa_approved === "pa_approved" ? [{
          name: "pa_approved_date",
          value: values.case_attributes.pa_approved_date,
        }]: []),
      ],
    };

    // const { case_attributes, uploaded_documents, ...actualCaseValues } = newValues;
    const { case_attributes, api_pa_approved, uploaded_documents, original_id, ...actualCaseValues } = newValues;
    //console.log("Case Submit........",actualCaseValues)
    addNewCase({
      case: actualCaseValues,
      ...(draftCaseId && draftCaseId !== 0 ? { draft_id: draftCaseId } : {})
    });
    // console.log({ case: actualCaseValues });
  };

  return { addCaseLoading, isUploading, caseDataSubmission };
}

export default useCaseCreateCall;
